export default {
    styleOverrides: {
        root: {
            textarea: {
                resize: "vertical"
            }
        },
    },
};
